//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { buyerShowList } from "@/api/buyerShow"
import TabBar from "@/components/footer";
export default {
  data() {
    return {
      sunbathingList1: [],
      sunbathingList2: [],
      loadmore: false,
      imgUrl: "https://img.reflower.com.cn/",
      miscurl: "https://misc.reflower.com.cn/",
    };
  },

  components: {
    TabBar
  },

  computed: {},

  created() {
    this.getBuyerShowList()
  },

  mounted() { },

  methods: {
    getBuyerShowList() {
      this.loadmore = true
      let params = {
        type : 1
      }
      buyerShowList(params).then(res => {
        this.loadmore = false
        for (let item in res.data) {
          let obj = res.data[item];
          obj.userImg = this.getRandomInt(1, 10);
          if (item == 0) {
            this.sunbathingList1.push(obj)
          } else {
            if (this.isOdd(Number(item))) {
              this.sunbathingList2.push(obj)
            } else {
              this.sunbathingList1.push(obj)
            }
          }
        }
      })
    },
    //获取随机数
    getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    isOdd(number) {
      // 检查传入的参数是否是有效的数字  
      if (typeof number !== 'number' || isNaN(number)) {
        return '不是有效的数字';
      }
      // 使用模运算符（%）来检查余数  
      if (number % 2 === 0) {
        return true;
      } else {
        return false;
      }
    },
    checkFun(item1) {
      this.$router.push({
        path: "/buyerShowPage",
        query: {
          id: item1.id
        }
      })
    }
  }
}




// WEBPACK FOOTER //
// ./src/view/buyersShow/buyerShowList.vue